import component from './PromoCodePage.vue'
export default component
